import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { map, filter, reduce } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModule, NgbModal, ModalDismissReasons, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { AuthService } from '../Services/auth.service';
import { Logininfo } from '../classes/Loginifo';
import { MiraieService } from '../Services/miraie.service';
import { SearchService } from '../Services/search-condition.service';
import { OutputService } from '../Services/output.service';

@Component({
  selector: 'app-work-step-list',
  templateUrl: './work-step-list.component.html',
  styleUrls: ['./work-step-list.component.css']
})
export class WorkStepListComponent implements OnInit {
  logininfo: Logininfo = this.auth.loginID;
  customerAllList: any;
  customerList: any;

  view_type: string = 'all';
  srcurl: string;

  constructor(
    public auth: AuthService,
    private miraieService: MiraieService,
    private searchService: SearchService,
    private outputService: OutputService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.srcurl = this.miraieService.srcurl;
    if (this.logininfo.authority_code > 2 && (this.logininfo.is_construction || this.logininfo.is_sales)) {
      this.view_type = 'personal';
    }
    this.getCustomerSchedule();
  }

  getCustomerSchedule() {
    this.searchService.getCustomerSchedule(this.logininfo.user_code).subscribe(list => {
      this.customerAllList = list;
      this.filterSchedule();
    });

  }
  filterSchedule() {
    this.customerList = this.customerAllList.filter((sc) => {
      if (this.view_type == 'personal') {
        if (this.logininfo.is_construction) {
          return !!(sc.directer_code == this.logininfo.user_code);
        } else if (this.logininfo.is_sales) {
          return !!(sc.sales_contact_code == this.logininfo.user_code);
        } else {
          return true;
        }
      } else {
        return true;
      }
    });
  }
  viewTypeChange() {
    this.filterSchedule();
  }
  //顧客詳細へ
  customerDetail(id, tab = 0, ref = 0) {
    this.router.navigate(['/detail/' + id + '/' + tab + '/' + ref]);
  }

  isScheduleColor(target_date, result_date) {
    if (target_date) {
      if (result_date) {
        return '';
      }
      let target = new Date(target_date);
      let today = new Date();
      let week = new Date();
      week.setDate(week.getDate() + 7);
      /** 時分秒ミリ秒をそろえる */
      target.setHours(0);
      today.setHours(0);
      week.setHours(0);

      target.setMinutes(0);
      today.setMinutes(0);
      week.setMinutes(0);

      target.setSeconds(0);
      today.setSeconds(0);
      week.setSeconds(0);

      target.setMilliseconds(0);
      today.setMilliseconds(0);
      week.setMilliseconds(0);

      if (target.getTime() < week.getTime() && target.getTime() >= today.getTime()) {
        return 'schdule-near';
      }
      if (target.getTime() < today.getTime()) {
        return 'schdule-over';
      }

    }
    return '';
  }
  output() {
    let res = this.outputService.proccess(this.customerAllList)
    res.subscribe(res => {
      const url = this.srcurl + "output/process/工程表.xlsx";
      window.open(url);
    });

  }
}
